interface User {
	accountId: string;
}

export const distinct = <T,>(
	list: readonly (T | null | undefined)[],
	getId: (listItem: T | undefined | null) => string | number | undefined | null,
): (T | null | undefined)[] => {
	const result: (T | null | undefined)[] = [];
	const seen = new Map();
	list.forEach((item) => {
		if (!seen.has(getId(item))) {
			seen.set(getId(item), true); // set any value to Map
			result.push(item);
		}
	});
	return result;
};

export const distinctUsers = <T extends User>(userList: (T | null | undefined)[]) =>
	distinct(userList, (user) => user?.accountId);

// This is exclusively used by vr tests to snapshot an open filter popup menu.
export const useDefaultIsOpen = () => false;
